import { getSummaryDetailsForFieldWithProductCatalog } from '../../vulcanPricing/utils/getFieldSummaryDetails';
import { getLocale } from '../../../misc';

export const getOfferDetailsOfCouppon = couponData => {
  const data = [];
  const locale = getLocale();
  const isEnglish = locale === 'en-US';
  const summaryDetails = getSummaryDetailsForFieldWithProductCatalog(
    couponData
  );
  if (summaryDetails.length > 0) {
    summaryDetails.forEach(offerData => {
      if (isEnglish) {
        data.push(offerData.offerDetailsEn);
      } else {
        data.push(offerData.offerDetailsFr);
      }
    });
  }
  return data;
};
